var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.65 2.25H10.75V12.9969L7.82733 10.299L6.5386 11.6952L11.7263 16.4838L16.5485 11.6616L15.205 10.3181L12.65 12.8732V2.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65 13.4167H2.75V16.2149C2.74998 16.8765 2.74997 17.4435 2.79701 17.9059C2.84679 18.3952 2.95696 18.8713 3.24717 19.3056C3.46239 19.6277 3.73896 19.9043 4.06107 20.1195C4.49539 20.4097 4.97147 20.5199 5.46078 20.5697C5.92322 20.6167 6.49019 20.6167 7.15187 20.6167H16.2481C16.9098 20.6167 17.4768 20.6167 17.9392 20.5697C18.4285 20.5199 18.9046 20.4097 19.3389 20.1195C19.661 19.9043 19.9376 19.6277 20.1528 19.3056C20.443 18.8713 20.5532 18.3952 20.603 17.9059C20.65 17.4435 20.65 16.8765 20.65 16.2148V13.4167H18.75V16.1667C18.75 16.8888 18.7488 17.3587 18.7127 17.7136C18.6783 18.0527 18.6199 18.1799 18.573 18.25C18.4964 18.3647 18.398 18.4631 18.2833 18.5397C18.2133 18.5866 18.086 18.6449 17.7469 18.6794C17.392 18.7155 16.9222 18.7167 16.2 18.7167H7.2C6.47785 18.7167 6.00797 18.7155 5.65307 18.6794C5.31397 18.6449 5.18674 18.5866 5.11665 18.5397C5.002 18.4631 4.90357 18.3647 4.82696 18.25C4.78013 18.1799 4.72175 18.0527 4.68726 17.7136C4.65115 17.3587 4.65 16.8888 4.65 16.1667V13.4167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadWhite);
export default __webpack_public_path__ + "static/media/download-white.7f52b5a6f645773a860c870993462cf0.svg";
export { ForwardRef as ReactComponent };